import util from '@/tools/commonUtil'
const validQuLogics = function (question, logic, quItem, toQuItem, value, anQuItemId) {
  let isShow = true
  const { logicType, sortQuItemId, chooseType } = logic
  if ([1, 'question'].includes(logicType) || [2, 'clientProperty'].includes(logicType)) {
    isShow = commonValidLogic(chooseType, quItem, sortQuItemId, anQuItemId)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(logicType, quItem, sortQuItemId, anQuItemId)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId) {
  let resultStr = ''
  const { logicType } = logic
  let anValue = []
  if (logic.anValue) {
    // 显示逻辑/内容逻辑
    anValue = logic.anValue.split(',')
  } else if (logic.sortQuItemId) {
    // 答案逻辑
    anValue = logic.sortQuItemId.split(',')
  }
  resultStr = !commonValidLogic(logicType, quItem, anValue, anQuItemId)
  return resultStr
}

const commonValidLogic = (logicType, quItem, sortQuItemId, anQuItemId) => {
  let isShow = true
  sortQuItemId = util.str2arr(sortQuItemId)
  if (!quItem.optionList) {
    isShow = false
  }

  const anQuItem = quItem.optionList.find(item => item.id === anQuItemId[0])
  if (anQuItem) {
    if (sortQuItemId.includes(anQuItem.value.toString())) {
      isShow = false
    }
  }

  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/SortBox/logic.js